var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_3308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_580_3308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.5V0.5H23.5V23.5H0.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_580_3308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.995 0.874023C6.83102 0.874023 4.58501 5.55502 4.58501 8.64902C4.58501 10.962 4.92001 10.281 3.64001 13.102C2.07701 17.122 8.36301 18.765 12 18.765C15.637 18.765 21.922 17.122 20.36 13.102C19.08 10.281 19.415 10.962 19.415 8.64902C19.415 5.55502 17.168 0.874023 11.995 0.874023Z",
    stroke: "black",
    strokeWidth: 1.749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6951 21.8545C14.3679 22.252 13.9568 22.5721 13.4913 22.7919C13.0258 23.0117 12.5174 23.1257 12.0026 23.1257C11.4878 23.1257 10.9793 23.0117 10.5138 22.7919C10.0483 22.5721 9.63719 22.252 9.31006 21.8545",
    stroke: "black",
    strokeWidth: 1.749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_3308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.11fd70a2b99b86215acbe14276af1060.svg";
export { ForwardRef as ReactComponent };